import { render, staticRenderFns } from "./BaseSpecialAutocomplete.vue?vue&type=template&id=644db798&"
import script from "./BaseSpecialAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BaseSpecialAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports